<section class="seller-container">
  <section class="ids-mv-4 ids-pt-8">
    <form [formGroup]="formStepThree" autocomplete="off">
      <app-seller-data-pay-pj
        (currentAccounts)="reciverCurrentAccounts($event)"
        [formStepDataPay]="formStepThree"
        [dataCompany]="dataCompany"
        [listAccount]="listAccount"
      >
      </app-seller-data-pay-pj>
    </form>
  </section>
</section>
